import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import SideScroll from '~/components/SideScroll.vue';
import Card from '~/components/cards/Card.vue';
import WebpPicture from '~/components/WebpPicture.vue';
import Certificate from '~/components/Certificate.vue';
import { useCourseLandingStore } from '~/stores/courseLanding';
export default {
  __name: 'Slides',
  props: {
    block: Object,
    edit: Boolean
  },
  setup: function setup(__props) {
    var props = __props;
    var courseLandingStore = useCourseLandingStore();
    var locale = computed(function () {
      return courseLandingStore.locale;
    });
    var course = computed(function () {
      return courseLandingStore.course;
    });
    var uid = ref(0);
    var allowedSlides = ['theory', 'practice', 'certificate', 'map', 'community', 'modes'];
    var slides = computed(function () {
      var slides = [];
      var _iterator = _createForOfIteratorHelper(props.block.slides),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var slide = _step.value;
          if (allowedSlides.includes(slide)) slides.push(slide);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return slides;
    });
    function toDouble(d) {
      return d >= 10 ? d : "0".concat(d);
    }
    var certData = computed(function () {
      var _course$value, _course$value2, _course$value3, _course$value4, _course$value5, _course$value6, _course$value7, _course$value8, _course$value9;
      var separatedMark = {
        theory: 88,
        practice: 100
      };
      var d = new Date();
      d = "".concat(toDouble(d.getDate()), ".").concat(toDouble(d.getMonth() + 1), ".").concat(toDouble(d.getFullYear()));
      var name = {
        uk: {
          "givenName": "Марічка",
          "familyName": "Смілива"
        },
        en: {
          "givenName": "Olivia",
          "familyName": "Smart"
        }
      };
      return {
        givenName: name[locale.value].givenName,
        familyName: name[locale.value].familyName,
        certDate: d,
        certId: 'AAA111',
        averageMark: 94,
        separatedMark: separatedMark,
        position: 234,
        courseName: course === null || course === void 0 ? void 0 : (_course$value = course.value) === null || _course$value === void 0 ? void 0 : _course$value.name,
        courseNames: course === null || course === void 0 ? void 0 : (_course$value2 = course.value) === null || _course$value2 === void 0 ? void 0 : _course$value2.names,
        pattern: (course === null || course === void 0 ? void 0 : (_course$value3 = course.value) === null || _course$value3 === void 0 ? void 0 : _course$value3.certPattern) || '/images/creative-practice/certificate/certificate-pattern-full.png',
        patternLight: (course === null || course === void 0 ? void 0 : (_course$value4 = course.value) === null || _course$value4 === void 0 ? void 0 : _course$value4.certPatternLight) || false,
        logo: (course === null || course === void 0 ? void 0 : (_course$value5 = course.value) === null || _course$value5 === void 0 ? void 0 : _course$value5.certLogo) || '/images/creative-practice/certificate/cp-logo-s.svg',
        logoBg: (course === null || course === void 0 ? void 0 : (_course$value6 = course.value) === null || _course$value6 === void 0 ? void 0 : _course$value6.certLogoBg) || '#0E1014',
        company: (course === null || course === void 0 ? void 0 : (_course$value7 = course.value) === null || _course$value7 === void 0 ? void 0 : _course$value7.certCompany) || null,
        companySingle: (course === null || course === void 0 ? void 0 : (_course$value8 = course.value) === null || _course$value8 === void 0 ? void 0 : _course$value8.certCompanySingle) || false,
        type: course === null || course === void 0 ? void 0 : (_course$value9 = course.value) === null || _course$value9 === void 0 ? void 0 : _course$value9.type
      };
    });
    return {
      __sfc: true,
      courseLandingStore: courseLandingStore,
      locale: locale,
      course: course,
      props: props,
      uid: uid,
      allowedSlides: allowedSlides,
      slides: slides,
      toDouble: toDouble,
      certData: certData,
      SideScroll: SideScroll,
      Card: Card,
      WebpPicture: WebpPicture,
      Certificate: Certificate
    };
  }
};